/*
 * @Description: 
 * @Author: zhaoshuai
 * @Date: 2021-03-02 10:14:32
 * @LastEditTime: 2021-05-28 14:48:46
 * @LastEditors: dezhi
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { routeList } from './routes'

let rList = routeList.map(item => {
    return {
        path: `/${item.name.toLowerCase()}`,
        name: item.name,
        component: () =>
            import(`../views/${item.name}.vue`)
    }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    ...rList
]


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router